var map = {
	"./ns_base.jpg": "3b91",
	"./ns_feel.jpg": "d38c",
	"./ns_in.jpg": "6bfb",
	"./ns_out.jpg": "ccc8",
	"./ns_power.jpg": "f0fa",
	"./ns_safe.jpg": "2cf3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5a01";